import get from 'lodash/get';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

const REAXYS_DB = '0';
const RMC_DB = '7';

class BuildInfo {
  static prepareDatabaseUpdateInfo(databases) {
    const { lastUpdated } = databases[REAXYS_DB];

    const objectContexts = {};
    const keys = Object.keys(databases);
    keys.forEach((key) => {
      if (key !== REAXYS_DB && key !== RMC_DB) {
        return;
      }
      const database = get(databases, key, {});

      database.availableContexts.forEach((context) => {
        const name = context.serverAlias;
        if (!name) {
          return;
        }

        if (key === RMC_DB && (name === 'substances' || name === 'citations' || name === 'patents' || name === 'reactions')) {
          return;
        }

        if (objectContexts[name]) {
          objectContexts[name].entriesCountIncrement += context.entriesCountIncrement;
          return;
        }
        objectContexts[name] = {
          entriesCountIncrement: context.entriesCountIncrement,
          displayName: context.displayName,
        };
      });
    });

    return {
      lastUpdated,
      contexts: objectContexts,
    };
  }

  static getBuildInfo() {
    return MessageBroker.send(RequestUrls.buildInfo)
      .then((buildInfo) => ({
        updateInfo: this.prepareDatabaseUpdateInfo(buildInfo.databases),
        ...buildInfo,
      }))
      .catch(Logger.reject);
  }
}

export default BuildInfo;
